// BlockingLoader.tsx
import React from 'react';
import './BlockingLoader.css';
import LoadingSpinner from '../LoadingSpinner';

/**
 * A loader that dims and blocks actions in the container it's in.
 * If you want this to work in a container, the container must have position: relative in it's CSS.
 * Refer to DocumentUploadForm for an example
 */
function BlockingLoader(): JSX.Element {
  return (
    <div className="BlockingLoaderOverlay">
      <LoadingSpinner light={true} />
    </div>
  );
}

export default BlockingLoader;
